import type { RouteWithTitle } from '@pbk-web/types';
import { Roles } from '@pbk-web/types';
import type { FC } from 'react';
import { lazy } from 'react';

const trainingRoutes: RouteWithTitle[] = [
  {
    id: 'training-v2',
    path: '/clients/:clientId/training/v2',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/TrainingV2')),
    permissions: [Roles.Management, Roles.TeamLead],
    canOverridePermissions: true,
  },
  {
    id: 'training-lib',
    path: '/clients/:clientId/training',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/TrainingLibrary')),
    permissions: [Roles.Management],
    canOverridePermissions: true,
  },
  {
    id: 'training-new',
    path: '/clients/:clientId/training/create',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/Training')),
    permissions: [Roles.Management],
  },
  {
    id: 'training',
    path: '/clients/:clientId/training/:trainingId',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/Training')),
    permissions: [Roles.Management],
    canOverridePermissions: true,
  },
  {
    id: 'training-event',
    path: '/clients/:clientId/training/:trainingId/events/:trainingEventId',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/TrainingEventPage')) as unknown as FC,
    permissions: [Roles.Employee],
  },
  {
    id: 'training-event-start',
    path: '/clients/:clientId/training/:trainingId/events/:trainingEventId/start',
    translationKey: 'page.training',
    component: lazy(() => import('../pages/TraineeFlow')),
    permissions: [Roles.Employee],
  },
];

export default trainingRoutes;
